// src/utils/publiekeDoorloopjes.js
// De publieke voorvertoningen (/alle-doorloopjes, /doorloopje/:slug, /waarom/:slug, /hoe/:slug)
// staan alleen aan als de backend ze geeft (PUBLIC_PREVIEWS). Antwoordt de lijst met 404, dan toont de site geen link,
// geen overzicht en geen voorvertoning. De lijst wordt één keer per paginabezoek opgehaald.
import { useEffect, useState } from 'react';
import axios from 'axios';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

export { OVERZICHT_PAD } from './publiekOverzicht';

let lijst = null;

// doorloopjes: de lijst (doorloopjes en waarom- en hoe-stukken, elk met zijn type), of null als de voorvertoningen uit staan of het laden mislukte (fout).
function haalLijst() {
  if (!lijst) {
    lijst = axios
      .get(`${STRAPI_URL}/api/doorloopjes/preview`)
      .then((res) => ({ doorloopjes: res.data?.data || [], fout: false }))
      .catch((err) => {
        if (err.response?.status === 404) return { doorloopjes: null, fout: false };
        console.error('Fout bij het ophalen van de publieke doorloopjes:', err);
        lijst = null;
        return { doorloopjes: null, fout: true };
      });
  }
  return lijst;
}

export function usePubliekeDoorloopjes() {
  const [state, setState] = useState({ loading: true, doorloopjes: null, fout: false });
  useEffect(() => {
    let actief = true;
    haalLijst().then((uitkomst) => actief && setState({ loading: false, ...uitkomst }));
    return () => {
      actief = false;
    };
  }, []);
  return state;
}
